@if (config) {
<div class="echart-card">
  <div class="echart-card__header">
    <h4 class="echart-card__title">{{ config.title }}</h4>
    <span class="echart-card__badge">{{ typeName }}</span>
  </div>
  <div #chartEl class="echart-card__canvas"></div>
</div>
}
